import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getToastMessage } from '@rsos/components/capstone/EmergencyCallsToast/helpers';
import { StateWithEmergencyCalls } from '@rsos/reduxDataStore/src/features/emergencyCalls/emergencyCallsSlice';
import { getMostRecentLoc } from '@rsos/utils/getMostRecentLoc';
import {
  dismissToastByID,
  notifyGenericEmergencyCall,
} from '@rsos/utils/toastUtils';
import usePrevious from '@rsos/utils/usePrevious';

const useAllEmergencyCallToastNotifications = () => {
  const { callQueue, selectedCallerID, numberWithNewLocation, locationType } =
    useSelector((state: StateWithEmergencyCalls) => state.emergencyCalls);

  const numbers = Object.keys(callQueue);
  const prevNumbers = usePrevious(numbers) as string[];

  // Show toast if a new number is added to the callQueue that matches criteria
  useEffect(() => {
    if (
      prevNumbers &&
      numberWithNewLocation &&
      numbers.length !== prevNumbers.length
    ) {
      const notifiedCall = callQueue[numberWithNewLocation];
      const mostRecentLocation = getMostRecentLoc(notifiedCall);

      if (getToastMessage(mostRecentLocation)) {
        notifyGenericEmergencyCall({
          emergencyCall: callQueue[numberWithNewLocation],
          locationType: locationType,
          options: {
            toastId: `emergency-calls-toast-${numberWithNewLocation}`,
          },
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [numbers, prevNumbers, numberWithNewLocation]);

  // Remove toast if its id matches selectedCallerID
  useEffect(() => {
    if (selectedCallerID) {
      dismissToastByID(`emergency-calls-toast-${selectedCallerID}`);
    }
  }, [selectedCallerID]);
};

export default useAllEmergencyCallToastNotifications;
